export default function Editorial() {
  return (
    <section className="bg-white text-neutral-900">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-24 md:py-40">
        <p className="overline text-neutral-400 reveal">Estudio</p>
        <h2 className="font-display font-medium tracking-tightest text-[clamp(2.4rem,7vw,6.5rem)] leading-[1.02] mt-8 max-w-5xl reveal">
          Creamos espacios. Desarrollamos ideas. Construimos proyectos.
        </h2>
        <div className="mt-12 md:mt-16 max-w-2xl md:ml-auto reveal">
          <p className="text-lg md:text-xl text-neutral-600 leading-relaxed">
            AM Estudio desarrolla proyectos arquitectónicos desde su etapa
            conceptual hasta la ejecución de obra, integrando diseño,
            planificación, visualización y construcción dentro de un mismo
            proceso.
          </p>
        </div>
      </div>
    </section>
  );
}